import React, { useState, useEffect } from "react";
import { loadCurrentNotifications } from "../../../api/notifications";
import "./notifications.css";

const NotificationsArea = () => {
  const [notifications, setNotifications] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    const stored = localStorage.getItem("dismissedNotifications");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    let isMounted = true;

    const fetchNotifications = async () => {
      try {
        const fetched = await loadCurrentNotifications();
        if (!isMounted) return;

        const valid = fetched.filter((n) => !dismissed.includes(n.id));
        setNotifications(valid);
      } catch (error) {
        if (isMounted) {
          console.error("Failed to load notifications:", error);
        }
      }
    };

    fetchNotifications();

    return () => {
      isMounted = false;
    };
  }, [dismissed]);

  const handleDismiss = (id) => {
    const newDismissed = [...dismissed, id];
    setDismissed(newDismissed);
    localStorage.setItem("dismissedNotifications", JSON.stringify(newDismissed));
    setNotifications(notifications.filter((n) => n.id !== id));
  };

  if (!notifications.length) {
    return null;
  }

  return (
    <div className="notification-container">
      {notifications.map((n) => (
        <div key={n.id} className="notification-box">
          <div style={{ flex: 1 }}>
            <h4 className="title mb-2">{n.title}</h4>
            <div dangerouslySetInnerHTML={{ __html: n.content }} />
          </div>
          <button
            type="button"
            className="btn-close btn-close-white notification-close"
            aria-label="Close"
            onClick={() => handleDismiss(n.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationsArea;